import { Route, Routes } from 'react-router-dom';
import { RouteConfig } from '@app/types';
import { CustomNavigate } from './CustomNavigate';

export type NavRoutesProps<TPath extends string> = {
  defaultRoute: TPath;
  routes: RouteConfig<TPath>[];
};

export function NavRoutes<TPath extends string>({
  defaultRoute,
  routes
}: NavRoutesProps<TPath>) {
  return (
    <Routes>
      {routes.map(({ component: Component, isParent, path }) => {
        return (
          <Route
            key={path}
            path={(!isParent) ? path : `${path}/*`}
            element={<Component />}
          />
        );
      })}
      <Route
        path="*"
        element={<CustomNavigate to={defaultRoute} />}
      />
    </Routes>
  );
}
